<h3 mat-dialog-title >choose name</h3>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>name</mat-label>
    <input matInput [(ngModel)]="name" (input)="onInput()">
  </mat-form-field>
  <div class="center-container">
    <p id="errorMessage">{{errorMessage}}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-green"
    type="button"
    [disabled]="error"
    (click)="onSend()">
    OK
  </button>
</mat-dialog-actions>
